// export { default as Other } from './other';
import { useFlags } from 'launchdarkly-react-client-sdk';

import OtherForm from './other';
import OtherFormNew, { Props } from './otherNew';

export const Other = ({ closeModal }: Props) => {
  const { enableDateTimeUpdates } = useFlags();

  return enableDateTimeUpdates ? (
    <OtherFormNew closeModal={closeModal} />
  ) : (
    <OtherForm closeModal={closeModal} />
  );
};
